import { Link } from "@amzn/awsui-components-react";
import * as React from "react";
import { usePageLibraryDataCache } from "../../hooks/use-page-library-data-cache";

export const PageLibraryLink = (props: {
    id: string;
    external?: boolean;
    pageLibraryName?: string;
}) => {
    const { pageLibraryCache, loadPageLibraryData } = usePageLibraryDataCache();

    React.useEffect(() => {
        if (props.id && !props.pageLibraryName) {
            loadPageLibraryData([props.id]);
        }
    }, [props.id, props.pageLibraryName, loadPageLibraryData]);

    const pageLibraryData = props.id ? pageLibraryCache[props.id] : undefined;
    const displayName = props.pageLibraryName || (pageLibraryData?.name) || props.id;

    return (
        <Link external={props.external} variant="secondary" href={`#/page-library/${props.id}/admin`}>
            {displayName}
        </Link>
    );
};

export const PageLibraryDisplay = (props: {
    id: string;
}) => {
    const { pageLibraryCache, loadPageLibraryData } = usePageLibraryDataCache();

    React.useEffect(() => {
        if (props.id) {
            loadPageLibraryData([props.id]);
        }
    }, [props.id, loadPageLibraryData]);

    const pageLibraryData = props.id ? pageLibraryCache[props.id] : undefined;
    const displayName = pageLibraryData?.displayName || pageLibraryData?.name || props.id;

    return (
        <React.Fragment>
            {displayName}
        </React.Fragment>
    );
};
